import { render, staticRenderFns } from "./BaseCard.vue?vue&type=template&id=68eae70e&scoped=true&lang=pug&"
import script from "./BaseCard.vue?vue&type=script&lang=js&"
export * from "./BaseCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCard.scss?vue&type=style&index=0&id=68eae70e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68eae70e",
  null
  
)

export default component.exports